/**
 * FAQSection - 常见问题手风琴
 * FAQ数据由Mpro.liquid页面传入
 */
var FAQSection = {
  faqs: [],

  openId: null,

  init: function () {
    var self = this;
    var list = document.getElementById('faqList');
    if (!list) return;

    var html = '';
    this.faqs.forEach(function (faq, index) {
      if (index !== 0) {
        html += '<div class="border-t border-white/20"></div>';
      }
      html += '<button class="w-full flex items-start justify-between gap-6 py-7 text-left group" onclick="FAQSection.toggle(' + faq.id + ')" data-faq-id="' + faq.id + '">';
      html += '<span class="text-lg md:text-xl font-semibold text-white leading-snug flex-1">' + faq.question + '</span>';
      html += '<span class="flex-shrink-0 mt-1">';
      html += '<svg class="w-5 h-5 text-white opacity-80 faq-icon-' + faq.id + '" fill="none" stroke="currentColor" viewBox="0 0 24 24">';
      html += '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14m-7-7h14"/>';
      html += '</svg></span></button>';
      html += '<div id="faq-answer-' + faq.id + '" class="faq-answer overflow-hidden transition-all duration-300" style="max-height:0">';
      html += '<div class="pb-7 -mt-2">';
      html += '<p class="text-base text-white/75 leading-relaxed">' + faq.answer + '</p>';
      html += '</div></div>';
    });

    list.innerHTML = html;
  },

  toggle: function (id) {
    if (this.openId === id) {
      this.close(id);
      this.openId = null;
    } else {
      if (this.openId !== null) {
        this.close(this.openId);
      }
      this.open(id);
      this.openId = id;
    }
  },

  open: function (id) {
    var answer = document.getElementById('faq-answer-' + id);
    if (answer) {
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
    var icon = document.querySelector('.faq-icon-' + id);
    if (icon) {
      icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14"/>';
    }
  },

  close: function (id) {
    var answer = document.getElementById('faq-answer-' + id);
    if (answer) {
      answer.style.maxHeight = '0px';
    }
    var icon = document.querySelector('.faq-icon-' + id);
    if (icon) {
      icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14m-7-7h14"/>';
    }
  }
};
